<ngx-spinner
bdColor="rgba(0, 0, 0, 0.5)"
size="small"
color="#fff"
[fullScreen]="true"
template="<img src='assets/img/Spinner.gif' alt=''/>"></ngx-spinner>

<app-modal></app-modal>

<app-header></app-header>
<app-navbar></app-navbar>
<app-nav-user *ngIf="isLoggedIn && isLogin()"></app-nav-user>
<app-user-dashboard *ngIf="isLoggedIn && isLogin()"></app-user-dashboard>

<div
  class="container"
  [ngClass]="isLoggedIn && showSideBar() ? 'wrapper-admin' : 'wrapper'">
  <div class="d-flex">
    <!-- Sidebar -->
    <app-sidebar
      [isCollapsed]="isCollapsed"
      *ngIf="isLoggedIn && showSideBar()"></app-sidebar>

    <!-- Main Content -->
    <div
      id="main"
      [class.margin-collapsed]="isCollapsed"
      [class.margin-expanded]="!isCollapsed"
      class="flex-grow-1">
      <div
        [ngClass]="isLoggedIn && showSideBar() ? 'content-admin' : 'content'">
        <router-outlet></router-outlet>
        <!-- GIF Element -->
        <app-justino-anime></app-justino-anime>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
<div class="barra-accesibilidad-govco">
  <button
    id="botoncontraste"
    class="contrast"
    aria-label="Cambiar contraste"
    (click)="cambiarContexto(!isDarkMode)">
    <span class="govco-contrast"></span>
  </button>
  <button
    id="botondisminuir"
    class="decrease-font-size"
    aria-label="Disminuir letra"
    (click)="disminuirTamanio()">
    <span class="govco-font-minimize"></span>
  </button>
  <button
    id="botonaumentar"
    class="increase-font-size"
    aria-label="Aumentar letra"
    (click)="aumentarTamanio()">
    <span class="govco-font-maximize"></span>
  </button>
</div>
